import { render, staticRenderFns } from "./RirekishoEduHistoryCard.vue?vue&type=template&id=50999050&scoped=true"
import script from "./RirekishoEduHistoryCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./RirekishoEduHistoryCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RirekishoEduHistoryCard.vue?vue&type=style&index=0&id=50999050&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50999050",
  null
  
)

export default component.exports